import React from 'react';
import PropTypes from 'prop-types';
import PageIntro from '../components/PageIntro';
import PageContent from '../components/PageContent';
import Cases from '../components/Cases';
import Meta from '../components/Meta';
import LogoAlypaa from '../images/logo-ap.png';
import LogoPelikone from '../images/logo-pk.png';
import LogoLP from '../images/logo-lp.png';
import LogoHGM from '../images/logo-hgm.png';
import LogoFP from '../images/logo-fp.png';
import LogoLePo from '../images/logo-lepo.png';
import LogoNaPo from '../images/logo-napo.png';

export default class LandingPage extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
    retryFetch: PropTypes.func
  }

  state = {
    entry: '4foIHMFcStSULLslCfU60N',
    data: this.props.data,
  };

  componentDidMount() {    
    window.scrollTo(0, 0);
    document.getElementsByTagName('html')[0].classList.remove('animate');
  }

  componentDidUpdate(prevProps) {
    // Update component state when props change
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  render() {
    const { loading, error, retryFetch } = this.props;

    if (error) {
      return (
        <section className="landing-page">
          <div className="error-container" style={{ textAlign: 'center', padding: '50px 20px' }}>
            <h2>Error loading content</h2>
            <p>{error}</p>
            <button 
              onClick={retryFetch}
              style={{
                padding: '10px 20px',
                background: '#c1347a',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px'
              }}
            >
              Try again
            </button>
          </div>
        </section>
      );
    }

    // Don't show anything during loading state
    if (loading) {
      return null;
    }

    return (
      <section className="landing-page">
        <Meta data={this.state.data} entry={this.state.entry} />
        <PageIntro data={this.state.data} entry={this.state.entry}>
          <div className="product-logos">
            <img loading="lazy" className="product-logo" src={LogoAlypaa} alt="Älypää"/>
            <img loading="lazy" className="product-logo" src={LogoPelikone} alt="Pelikone"/>
            <img loading="lazy" className="product-logo" src={LogoLP} alt="Liigapörssi"/>
            <img loading="lazy" className="product-logo" src={LogoHGM} alt="Hockey GM"/>
            <img loading="lazy" className="product-logo" src={LogoFP} alt="Futispörssi"/>
            <img loading="lazy" className="product-logo" src={LogoLePo} alt="Leijonapörssi"/>
            <img loading="lazy" className="product-logo" src={LogoNaPo} alt="Naisleijonapörssi"/>
          </div>
        </PageIntro>
        <PageContent data={this.state.data} entry={this.state.entry} />
        <Cases data={this.state.data} />
      </section>
    );
  }
}
